<template>
    <div class="w-100 h-100">
        <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
            <b-tab style="width: 100%; height:100%; overflow-y: scroll;" title="Agende" active>
                <div class="sa-free-page" style="padding-bottom: 60px;">
                    <div :class="['sa-free-page-body-row', isSidebarRistretta ? 'sidebar-collapsed' : '']"
                        style="background-color: transparent">

                        <b-button v-if="isSidebarRistretta" v-b-tooltip.hover size="sm" variant="light"
                            @click="isSidebarRistretta = !isSidebarRistretta"
                            :title="isSidebarRistretta ? 'Espandi Barra' : 'Riduci Barra'"
                            class="rounded-circle sa-ft-floating-btn border border-secondary sa-toggle-main-btn">
                            <b-icon :icon="isSidebarRistretta ? 'chevron-right' : 'chevron-left'"></b-icon>
                        </b-button>
                        <div class="sa-free-page-body-left" style="background-color: transparent">
                            <div
                                class="d-flex align-items-center mb-3 flex-wrap sa-agenda-sticky-header justify-content-between">
                                <b-form-datepicker id="datepicker-agenda" v-model="dataRiferimento" size="sm" local="it"
                                    placeholder="Seleziona una data"
                                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                                    class="w-50" @input="cambiaData">
                                </b-form-datepicker>
                                <div :style="{ display: 'flex', 'margin-left': 'auto', 'align-items': 'end' }">
                                    <template v-if="!isSidebarRistretta">
                                        <b-button v-b-tooltip.hover size="sm" variant="light"
                                            @click="isSidebarRistretta = !isSidebarRistretta"
                                            :title="isSidebarRistretta ? 'Espandi Barra' : 'Riduci Barra'"
                                            class="rounded-circle sa-ft-floating-btn border border-secondary">
                                            <b-icon
                                                :icon="isSidebarRistretta ? 'chevron-right' : 'chevron-left'"></b-icon>
                                        </b-button>
                                    </template>
                                </div>

                            </div>

                            <template v-if="!isSidebarRistretta">
                                <template v-if="agende.length > 0">
                                    <div v-for="a in agende" :key="a.id" class="sa-agenda-row-container">
                                        <div class="sa-agenda-btn-setting">
                                            <b-button v-b-tooltip.hover size="sm" variant="outline-secondary"
                                                @click.stop="onModificaAgendaSetting(a)" title="Gestisci Agenda"
                                                class="rounded-circle sa-ft-floating-btn secondary"
                                                style="margin-right: 10px;">
                                                <b-icon icon="gear"></b-icon>
                                            </b-button>
                                        </div>

                                        <div @click="toggleAgenda(a, false)"
                                            :class="['sa-agenda-selector-card', isSelezionata(a.id) ? 'is-selected' : '']">
                                            <div class="sa-agenda-card-info">
                                                <div class="sa-agenda-card-title">{{ a.titolo }}</div>
                                                <div class="sa-agenda-card-sub">
                                                    {{ a.specializzazione == null ? 'Nessuna' :
                                                        a.specializzazione.toUpperCase() }}
                                                </div>
                                            </div>
                                            <div class="sa-agenda-check-icon">
                                                <b-icon v-if="isSelezionata(a.id)" icon="check"
                                                    font-scale="1.2"></b-icon>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <no-data-component ref="cmpNoDataComponent" title="Nessuna Agenda Configurata"
                                        nome="no-data" :fontSize="10" subtitle="" icon="fas fa-calendar" />
                                </template>
                            </template>
                        </div>

                        <div class="sa-free-page-body-center-row" style="background-color: transparent">

                            <div v-if="agende.length == 0"
                                class="text-center p-5 bg-white rounded-lg border border-dashed w-100">
                                <no-data-component ref="cmpNoDataComponent" title="Nessuna Agenda Configurata"
                                    nome="no-data" :fontSize="20" subtitle="Configurare le Agende"
                                    icon="fas fa-calendar" />
                            </div>

                            <div v-else-if="agende.length > 0 && selezionateIds.length === 0"
                                class="text-center p-5 bg-white rounded-lg border border-dashed w-100">
                                <b-icon icon="calendar-plus" font-scale="3" class="text-light mb-3"></b-icon>
                                <h5 class="text-muted">Seleziona almeno un'agenda dal menu laterale</h5>
                            </div>

                            <div v-else class="sa-agenda-cards-wrapper">

                                <div v-for="agenda in agendeVisibili" :key="agenda.id"
                                    class="sa-agenda-card-block shadow-sm">

                                    <div class="sa-agenda-card-block-header text-center"
                                        :style="{ border: `1px solid ${getColorBorder(agenda)} !important` }">
                                        <div class="font-weight-bold text-dark text-truncate">{{ agenda.titolo }}
                                        </div>
                                        <div class="text-primary mt-1" style="font-size: 0.85rem;">
                                            <b-badge variant="light"
                                                :style="{ marginRight: '2px', border: `1px solid ${getColorBorder(agenda)} !important`, color: `${getColorBorder(agenda)} !important` }">
                                                {{ getDurataAppuntamentoByAgendaAndPrestazione(agenda) }} min
                                            </b-badge>


                                            <b-badge class="sa-ft-label" variant="light"
                                                :style="{ color: `${getColorSpecializzazione(agenda)} !important`, border: `1px solid ${getColorSpecializzazione(agenda)} !important` }">
                                                {{ agenda.specializzazione == null ? " NESSUNA" :
                                                    agenda.specializzazione.toUpperCase() }}
                                            </b-badge>
                                        </div>
                                        <!-- <b-form-select v-model="agenda.prestazioneSelezionata"
                                            :options="agenda.prestazioni" size="sm" class="sa-select-prestazioni"
                                            text-field="descrizionePrestazione" value-field="codicePrestazione">
                                        </b-form-select> -->
                                        <div
                                            style="width: 100%; margin-top: 5px; display: flex; justify-content: center">
                                            <div
                                                :style="{ border: `1px solid ${getColorBorder(agenda)}`, borderRadius: '8px', padding: '4px 12px', width: 'fit-content', textAlign: 'center' }">
                                                <label class="sa-ft-label"
                                                    :style="{ color: `${getColorBorder(agenda)} !important` }">
                                                    {{ getGiornoSettimana(dataRiferimento).toUpperCase() }}
                                                </label>
                                                <strong :style="{ color: getColorBorder(agenda) }">
                                                    {{ dataRiferimento.split("-").reverse().join("/") }}
                                                </strong>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="sa-agenda-card-block-body">

                                        <div v-for="(item, index) in timelineDinamicaPerAgenda(agenda)" :key="index"
                                            class="d-flex flex-column p-2 border-bottom w-100"
                                            :style="item.NessunaDisponibilita ? 'background-color: #fff3cd; min-height: 80px;' : (!item.isConfigurato ? 'background-color: #f1f3f5; min-height: 70px;' : 'min-height: 70px; background-color: #fff;')">

                                            <div v-if="item.NessunaDisponibilita"
                                                class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center p-2 w-100"
                                                style="user-select: none;">
                                                <span class="text-warning font-weight-bold" style="font-size: 0.85rem;">
                                                    <i class="bi bi-exclamation-triangle-fill mr-1"></i>
                                                    NON CONFIGURATO
                                                </span>
                                            </div>

                                            <template v-else>

                                                <div
                                                    class="d-flex justify-content-between align-items-center w-100 mb-1">
                                                    <div :class="['font-weight-bold', !item.isConfigurato ? 'text-muted' : '']"
                                                        style="font-size: 0.8rem;">
                                                        {{ item.orarioInizio }} - {{ item.orarioFine }}
                                                    </div>
                                                    <div v-if="item.isConfigurato" class="font-weight-bold text-primary"
                                                        style="font-size: 0.8rem;">
                                                        {{ item.occupati }}/{{ item.totali }}
                                                    </div>
                                                </div>

                                                <div v-if="item.isConfigurato" class="w-100 d-flex flex-column"
                                                    style="gap: 4px;">

                                                    <template v-for="(app, aIdx) in item.appuntamenti">
                                                        <div v-if="app.isOccupato" :key="'occ_' + aIdx"
                                                            :class="['sa-agenda-item p-2 rounded w-100 mb-1']"
                                                            :style="{ cursor: 'pointer', fontSize: '0.80rem', lineHeight: '1.2', border: `1px solid ${getColorAppuntamentoStatoApp(app.dati)}` }"
                                                            @click="gestisciAppuntamento(app.dati, agenda)">

                                                            <div class="d-flex flex-column w-100">
                                                                <div
                                                                    class="d-flex justify-content-between align-items-start w-100">
                                                                    <div class="font-weight-bold text-truncate mr-2"
                                                                        :title="`${app.dati.cognome || ''} ${app.dati.nome || ''} - ${app.dati.identificativoAppuntamento || '--'}`">
                                                                        {{ app.dati.cognome || 'Paziente' }} {{
                                                                            app.dati.nome || '' }}
                                                                        <span
                                                                            class="text-muted font-weight-normal ml-1">
                                                                            ({{ app.dati.identificativoAppuntamento
                                                                                || '--' }})
                                                                        </span>
                                                                    </div>

                                                                    <div class="badge text-white px-2 py-1"
                                                                        :style="{ backgroundColor: getColorAppuntamentoTipo(app) || '#6c757d', fontSize: '0.70rem', minWidth: '24px', textAlign: 'center' }"
                                                                        :title="app.dati.tipologiaVisita || 'Tipologia non definita'">
                                                                        {{app.dati.tipologiaVisita ?
                                                                            app.dati.tipologiaVisita.split(' ').map(w =>
                                                                                w[0]).join('').toUpperCase().substring(0, 3)
                                                                            : '-'}}
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    class="d-flex justify-content-between align-items-center mt-2 w-100">
                                                                    <div style="font-size: 1.6rem; line-height: 1;">
                                                                        {{
                                                                            getIconaByStatoPagamento(app.dati.statoAttualePagamento)
                                                                        }}
                                                                    </div>

                                                                    <div class="d-flex align-items-center text-right"
                                                                        style="min-width: 0;">
                                                                        <div class="text-muted text-truncate mr-1"
                                                                            :title="app.dati.codicePrestazione"
                                                                            style="font-size: 0.7rem;">
                                                                            {{ app.dati.codicePrestazione ||
                                                                                'Nessuna prestazione' }}
                                                                        </div>
                                                                        <div style="font-size: 1.6rem; line-height: 1;">
                                                                            {{
                                                                                getIconaByStato(app.dati.statoAttuale)
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>

                                                    <div v-if="item.occupati < item.totali" class="d-flex mt-1"
                                                        style="gap: 4px;">
                                                        <template v-for="(app, aIdx) in item.appuntamenti">
                                                            <b-button v-if="!app.isOccupato" :key="'lib_' + aIdx"
                                                                variant="outline-success"
                                                                class="flex-grow-1 p-0 d-flex justify-content-center align-items-center"
                                                                style="height: 24px; font-weight: bold; font-size: 0.85rem;"
                                                                title="Aggiungi prenotazione"
                                                                @click="nuovoAppuntamento(agenda, item)">
                                                                <i class="bi bi-calendar-plus"></i>
                                                            </b-button>
                                                        </template>
                                                    </div>
                                                </div>

                                                <div v-else
                                                    class="flex-grow-1 d-flex align-items-center justify-content-center rounded border border-dashed"
                                                    style="background-color: #e9ecef; border-color: #dee2e6 !important; user-select: none;">
                                                    <span class="text-muted font-italic"
                                                        style="font-size: 0.75rem; letter-spacing: 0.5px;">
                                                        Non configurato
                                                    </span>
                                                </div>

                                            </template>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>
            <b-tab style="overflow-y: scroll;" title="Appuntamenti">
                <AppuntamentiComponent :riferimento="dataRiferimento" ref="cmpAppuntamentiComponent" />
            </b-tab>
        </b-tabs>
        <b-modal ref="mdlAgendaConfigurazioni" size="xl" @shown="onShownAgendaConfigurazioni">
            <AgendaEditComponent ref="cmpAgendaEditComponent" />
            <template #modal-footer>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="secondary" @click="onCloseModal()">Chiudi</b-button>
                </div>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="primary" @click="onSalvaModificheConfigurazioneAgenda()">Salva</b-button>
                </div>
            </template>
        </b-modal>
        <b-modal ref="mdlAgendeConfigurazioniVisibilita" size="xl" @shown="onShowConfigurazioneVisibilita">
            <template #modal-footer>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="secondary" @click="onCloseModal()">Chiudi</b-button>
                </div>
                <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">
                    <b-button variant="primary" @click="onSalvaModificheConfigurazioneAgenda()">Salva</b-button>
                </div>
            </template>
        </b-modal>
        <AgendaAppuntamentoModal key="" ref="mdlAgendaAppuntamentoModal" @successRestCall="onSuccessRestCall">
        </AgendaAppuntamentoModal>
    </div>
</template>

<script>
import axios from 'axios';
import NoDataComponent from '../../../template/components/utility/NoDataComponent.vue';
import AgendaEditComponent from '../../agende/components/AgendaEditComponent.vue';
import toast from '../../../template/layout/utility/sa-toast';
import AgendaAppuntamentoModal from "../components/AgendaAppuntamentoModal.vue"
import UtilityMixin from '../../utility/UtilityMixin';
// import DatePicker from "vue2-datepicker";
// import "vue2-datepicker/index.css";
// import AgendaAppuntamentiComponent from '../../agende/agenda/AgendaAppuntamentiComponent.vue';
import AppuntamentiComponent from './AppuntamentiComponent.vue';

export default {
    mixins: [UtilityMixin],
    components: { NoDataComponent, AgendaEditComponent, AgendaAppuntamentoModal, AppuntamentiComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            vista: "panoramica",
            isSidebarRistretta: false,
            selezionateIds: [],
            configurazioniAgenda: {
                orarioInizio: 7,
                orarioFine: 23
            },
            dataRiferimento: new Date().toISOString().split('T')[0],
            agendaSelezionataConfigurazione: null,
            pathResource: "/agende",
            pathResourceAppuntamenti: "/agendaappuntamenti",
            pathResourceDisponibilità: "/agendadisponibilita",
            objectAppuntamento: { id: "", idAgenda: "", codicePrestazione: "", descrizionePrestazione: "", dataOraInizio: "", dataOraFine: "", identificativoAppuntamento: "", costo: "", note: "" },
            agendaSelezionata: null,
            form: { cognome: "", ora: "", tipo: "VISITA" },
            agende: [],
            appuntamenti: [],
            tipologiaVisitaOptions: [],
            specializzazioniOptions: [],
            statiAppuntamentoOptions: [],
            statiPagamentiAppuntamento: [],
            tipologieAgendaOptions: [],
            agendeAppuntamenti: {}
        };
    },
    computed: {
        // appuntamentiMappati() {
        //     const mappa = {};
        //     this.agende.forEach(agenda => {
        //         if (agenda.disponibilita) {
        //             agenda.disponibilita.forEach(disp => {
        //                 if (disp.appuntamento && Array.isArray(disp.appuntamento)) {
        //                     disp.appuntamento.forEach(app => {
        //                         if (app && app.id) {
        //                             const chiave = `${agenda.id}_${this.dataRiferimento}_${disp.dalleOre}`;
        //                             if (!mappa[chiave]) mappa[chiave] = [];
        //                             mappa[chiave].push(app);
        //                         }
        //                     });
        //                 }
        //             });
        //         }
        //     });
        //     return mappa;
        // },
        agendeVisibili() {
            return this.agende.filter((a) => this.selezionateIds.includes(a.id));
        }
    },
    mounted() {
        this.loadConfiguration();
        this.loadAgende();
        this.loadDataTipologieVisita();
        this.loadDataSpecializzazioni();
        this.loadDataTipologieAgende();
        this.loadDataAgendaAppuntamentoPagamentoStati();
        this.loadStatiAgenda();

    },
    methods: {
        loadConfiguration() {

            let sessionStorage = window.sessionStorage;
            if (sessionStorage.getItem("configurazioniAgendaVisibilita")) {
                this.configurazioniAgenda = JSON.parse(sessionStorage.getItem("configurazioniAgendaVisibilita"));
            } else {
                this.saveConfigurazioni();
            }
        },
        getColorBorder(agenda) {
            let color = "";
            let a = this.tipologieAgendaOptions.find(e => e.nome == agenda.tipo)
            if (a) {
                color = a.color;
            }
            return color;
        },
        getColorAppuntamentoTipo(app) {
            let color = "";
            let a = this.tipologiaVisitaOptions.find(e => e.nome == app.dati.tipologiaVisita)
            if (a) {
                color = a.color;
            }
            return color;

        },
        getColorAppuntamentoStatoApp(app) {
            console.log(app);

            let color = "";
            let a = this.statiAppuntamentoOptions.find(e => e.nome == app.statoAttuale)
            if (a) {
                color = a.color;
            }
            return color;
        },


        getIconaByStato(appstato) {
            let icon = "";
            let a = this.statiAppuntamentoOptions.find(e => e.nome == appstato)
            if (a) {
                icon = a.icon;
            }
            return icon;


        },
        getIconaByStatoPagamento(statoPagamento) {
            console.log(statoPagamento);

            let icon = "";
            let a = this.statiPagamentiAppuntamento.find(e => e.nome == statoPagamento)
            if (a) {
                icon = a.icon;
            }
            return icon;


        },


        getColorSpecializzazione(agenda) {
            let color = "";
            let a = this.specializzazioniOptions.find(e => e.nome == agenda.specializzazione)
            if (a) {
                color = a.color;
            }
            return color;

        },

        getGiornoSettimana(dataStr) {
            if (!dataStr) return '';

            const dataObj = new Date(dataStr.replace(/-/g, '/'));


            return dataObj.toLocaleString('it-IT', { weekday: 'long' });
        },
        saveConfigurazioni() {
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("configurazioniAgendaVisibilita", JSON.stringify(this.configurazioniAgenda));

        },
        loadDataTipologieVisita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendatipovisite";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.tipologiaVisitaOptions = response.data.data.list;

                })
                .catch(() => { });

        },
        loadDataSpecializzazioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaspecializzazione";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.specializzazioniOptions = response.data.data.list;

                })
                .catch(() => { });

        },
        loadStatiAgenda() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentistati";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.statiAppuntamentoOptions = response.data.data.list;

                })
                .catch(() => { });
        },

        getFormatoData() {

        },

        loadDataTipologieAgende() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendatipo";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.tipologieAgendaOptions = response.data.data.list;

                })
                .catch(() => { });

        },
        loadDataAgendaAppuntamentoPagamentoStati() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentipagamentistati";
            me.showModalLoading = true;
            axios
                .get(link)
                .then((response) => {
                    this.statiPagamentiAppuntamento = response.data.data.list;

                })
                .catch(() => { });

        },


        onSuccessRestCall() {
            this.reloadAgende();
        },
        cambiaData() {
            this.appuntamenti = [];
            this.reloadAgende();
        },
        onCloseModal() {
            this.$refs.mdlAgendaConfigurazioni.hide();
        },
        onSalvaModificheConfigurazioneAgenda() {
            let jsonAgenda = this.$refs.cmpAgendaEditComponent.getJsonData();
            axios.put(process.env.VUE_APP_PATH_API + this.pathResource + "/" + jsonAgenda.id, jsonAgenda)
                .then((response) => {
                    toast.success(response.data.messaggio)
                    this.loadAgende();
                    this.onCloseModal();
                    this.reloadAgende();
                    this.closeShowModalLoading();
                }).catch((err) => {
                    console.error(err);
                });
        },
        reloadAgende() {
            const idsDaRicaricare = [...this.selezionateIds];
            this.selezionateIds = [];
            idsDaRicaricare.forEach(id => {
                let agenda = this.agende.find(e => e.id == id);
                if (agenda) {
                    this.toggleAgenda(agenda, false);
                }
            });
        },
        timelineDinamicaPerAgenda(agenda) {
            const listaSlot = [];
            if (!agenda) return listaSlot;

            // 1. CASO NULL / VUOTO: Se non c'è disponibilità reale, mostra subito l'avviso
            if (!agenda.disponibilita || !Array.isArray(agenda.disponibilita) || agenda.disponibilita.length === 0) {
                listaSlot.push({
                    orarioInizio: "--:--",
                    orarioFine: "--:--",
                    isConfigurato: false,
                    NessunaDisponibilita: true, // Attiva il box giallo nel template HTML
                    appuntamenti: [],
                    occupati: 0,
                    totali: 0
                });
                return listaSlot;
            }

            // 2. CASO STANDARD: Generiamo la timeline ciclando DIRETTAMENTE sugli slot reali del server
            agenda.disponibilita.forEach(slotReale => {
                let appuntamentiNormalizzati = [];
                let occupati = 0;

                // Estraiamo gli appuntamenti associati a questo specifico slot
                if (Array.isArray(slotReale.appuntamento)) {
                    slotReale.appuntamento.forEach(app => {
                        // Uno slot è occupato se l'oggetto appuntamento esiste, non è null ed è popolato
                        const isOccupato = app !== null && typeof app === 'object' && Object.keys(app).length > 0;
                        if (isOccupato) {
                            occupati++;
                        }

                        appuntamentiNormalizzati.push({
                            isOccupato: isOccupato,
                            dati: app,
                            orarioSpecifico: slotReale.dalleOre
                        });
                    });
                }

                // Se lo slot è vuoto (es. [null] come nel tuo JSON), garantiamo che ci sia almeno un posto cliccabile
                if (appuntamentiNormalizzati.length === 0) {
                    appuntamentiNormalizzati.push({
                        isOccupato: false,
                        dati: null,
                        orarioSpecifico: slotReale.dalleOre
                    });
                }

                // Il totale dei posti disponibili per questo slot specifico
                let totali = appuntamentiNormalizzati.length;

                // Spingiamo lo slot configurato nella lista finale
                listaSlot.push({
                    orarioInizio: slotReale.dalleOre, // Prende es: "10:00"
                    orarioFine: slotReale.alleOre,   // Prende es: "10:10"
                    isConfigurato: true,
                    appuntamenti: appuntamentiNormalizzati,
                    occupati: occupati,
                    totali: totali
                });
            });

            return listaSlot;
        },
        classificazioneDisponibilita(durata) {
            return durata;
        },
        onPrestazioneChange(agenda) {
            const agendaIndex = this.agende.findIndex(a => a.id === agenda.id);
            if (agendaIndex > -1) {
                this.$set(this.agende[agendaIndex], 'disponibilita', []);
            }
            this.toggleAgenda(agenda, true);
        },
        onShowConfigurazioneVisibilita() {
            console.log("show visibilita");

        },
        toggleAgenda(agenda, aggiornaPrestazione = false) {
            let id = agenda.id;
            const index = this.selezionateIds.indexOf(id);
            this.openShowModalLoading();
            if (index > -1 && !aggiornaPrestazione) {
                this.selezionateIds.splice(index, 1);
                this.closeShowModalLoading();
            } else {
                this.recuperaAggiornaAgenda(id, agenda, aggiornaPrestazione);
            }
        },
        recuperaAggiornaAgenda(id, agenda, aggiornaPrestazione = false) {
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + id;
            axios.get(link)
                .then((response) => {
                    let agendaDettaglio = response.data.data;
                    const agendaIndex = this.agende.findIndex(a => a.id === id);
                    let linkDisponibilita = process.env.VUE_APP_PATH_API + this.pathResourceDisponibilità;

                    if (agendaDettaglio.prestazioni.length == 0) {
                        toast.error("Configurare almeno una prestazione!");
                        this.closeShowModalLoading();
                        return;
                    }
                    agenda;
                    aggiornaPrestazione;
                    let codicePrestazione = agendaDettaglio.prestazioni[0].codicePrestazione;

                    let filter = {
                        idAgenda: id,
                        riferimento: this.dataRiferimento,
                        codicePrestazione: codicePrestazione,
                        periodo: 'G'
                    };

                    axios.get(linkDisponibilita, { params: filter })
                        .then((response) => {
                            let disponibilita = response.data.data;
                            let appuntamenti = [];
                            let listaDisponibilitaEstratta = [];
                            let parametriAgenda = []; // Creiamo una variabile locale per i parametri

                            // CASO 1: Il server risponde con dati VALIDI
                            if (disponibilita && Array.isArray(disponibilita) && disponibilita[0] && disponibilita[0].disponibilita) {
                                listaDisponibilitaEstratta = disponibilita[0].disponibilita;
                                parametriAgenda = agendaDettaglio.parametri || []; // Prendiamo i parametri normali

                                for (let dis of listaDisponibilitaEstratta) {
                                    let appuntamentiFascia = dis.appuntamento || [];
                                    let oggettiTrovati = appuntamentiFascia.filter(e => e != null);

                                    if (oggettiTrovati.length > 0) {
                                        appuntamenti.push(...oggettiTrovati);
                                    }
                                }
                            }
                            // CASO 2: Le disponibilità sono NULL (Il tuo caso attuale)
                            else {
                                console.warn(`Nessuna disponibilità (NULL) per l'agenda ${id}. Forzo il blocco.`);
                                listaDisponibilitaEstratta = [];
                                appuntamenti = [];
                                parametriAgenda = []; // <--- CHIAVE DI VOLTA: Svuotiamo i parametri così la timeline non genera le ore!
                            }


                            const agendaAggiornata = {
                                ...this.agende[agendaIndex],
                                parametri: parametriAgenda,
                                prestazioni: agendaDettaglio.prestazioni || [],
                                disponibilita: listaDisponibilitaEstratta,
                                durataAppuntamento: agendaDettaglio.durataAppuntamento || 30,
                                appuntamenti: appuntamenti
                            };


                            this.$set(this.agende, agendaIndex, agendaAggiornata);


                            if (!this.selezionateIds.includes(id)) {
                                this.selezionateIds.push(id);
                            }

                            this.closeShowModalLoading();
                        })
                        .catch((err) => {
                            console.error(err);
                            toast.error("Errore recupero appuntamenti");
                            this.closeShowModalLoading();
                        });
                })
                .catch((error) => {
                    console.error("Errore di caricamento:", error);
                    this.closeShowModalLoading();
                    alert("Impossibile recuperare i dettagli dell'agenda.");
                });
        },
        nuovoAppuntamento(agenda, slot) {
            let disponibilita = agenda.disponibilita || [];
            let prestazioniAgenda = agenda.prestazioni || [];

            if (disponibilita.length == 0) {
                toast.warning("Errore con il recupero delle disponibilità")
                return;
            }
            if (prestazioniAgenda.length == 0) {
                toast.warning("Non sono configurate prestazioni per agenda " + agenda.titolo)
                return;
            }


            let orarioInizio = this.parseFormatDateTime(this.dataRiferimento + " " + slot.orarioInizio, "YYYY-MM-DD HH:mm").getTime();
            let orarioFine = this.parseFormatDateTime(this.dataRiferimento + " " + slot.orarioFine, "YYYY-MM-DD HH:mm").getTime();
            let objectAppuntamento = {
                idAgenda: agenda.id,
                cognome: null,
                tipoIdentificativo: "CF",
                identificativoAppuntamento: null,
                codicePrestazione: null,
                descrizionePrestazione: null,
                dataOraInizio: orarioInizio,
                dataOraFine: orarioFine,
                dataRiferimento: orarioInizio,
                costo: null,
                nome: "",
                dataNascita: null,
                note: null,
            };

            this.$refs.mdlAgendaAppuntamentoModal.show(objectAppuntamento, agenda);
        },
        gestisciAppuntamento(appuntamento, agenda) {
            this.$refs.mdlAgendaAppuntamentoModal.show(appuntamento, agenda);
        },
        loadAgende() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.pathResource;
            axios.get(link)
                .then((response) => {
                    this.agende = response.data.data.map(agenda => {
                        return {
                            ...agenda,
                            disponibilita: [],
                            parametri: []
                        };
                    });
                    this.$emit("afterLoadData");
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    console.error(err);
                    this.$emit("afterLoadData");
                    this.closeShowModalLoading();
                });
        },
        onInputTabs(id) {
            switch (id) {
                case 0:

                    break;
                case 1:
                    this.$refs.cmpAppuntamentiComponent.init(this.agende, this.selezionateIds);
                    break;
                default:
                    break;
            }
        },
        onModificaAgendaSetting(agenda) {
            this.agendaSelezionataConfigurazione = agenda;
            this.$refs.mdlAgendaConfigurazioni.show();
        },
        onShownAgendaConfigurazioni() {
            let id = this.agendaSelezionataConfigurazione.primaryKey;
            this.openShowModalLoading();
            axios.get(process.env.VUE_APP_PATH_API + this.pathResource + "/" + id)
                .then((response) => {
                    this.$refs.cmpAgendaEditComponent.init(response.data.data);
                    this.closeShowModalLoading();
                }).catch(() => { this.closeShowModalLoading(); });
        },
        isSelezionata(id) { return this.selezionateIds.includes(id); },
        toggleTutte() {
            if (this.selezionateIds.length === this.agende.length) {
                this.selezionateIds = [];
                this.appuntamenti = [];
            } else {
                this.selezionateIds = this.agende.map((a) => a.id);
            }
        },
        getDurataAppuntamentoByAgendaAndPrestazione(agenda) {

            //let agendaPrestazioneSlot = agenda.prestazioni.find(e => e.codicePrestazione == agenda.prestazioneSelezionata);
            //const durata = parseInt(agendaPrestazioneSlot.durataAppuntamento) || agenda.durataAppuntamento;
            return agenda.durataAppuntamento;
        }
    }
};
</script>

<style>
.sa-agenda-cards-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    gap: 16px;
    overflow-x: auto;
    padding: 4px;
}

.sa-agenda-card-block {
    width: 260px;
    min-width: 260px;
    max-width: 260px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #e2e8f0;
}

.sa-agenda-card-block-header {
    padding: 10px;
    background-color: #fff;
    border-radius: 8px 8px 0 0;
}

.sa-agenda-card-block-body {
    flex: 1;
    overflow-y: auto;
    max-height: 65vh;
    background-color: #fafafa;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sa-ft-floating-btn {
    border-radius: 8px !important;
}

.sa-select-prestazioni {
    margin-top: 5px;
    font-size: 0.75rem;
    /* Rimpicciolisce il testo della tendina */
    height: auto;
    /* Permette alla select di adattarsi al nuovo padding */
    padding: 0.25rem 1.5rem 0.25rem 0.5rem;
    /* Riduce gli spazi interni */
    border-radius: 4px;
    border: 1px solid #ced4da;
    color: #495057;
    background-color: #fff;
    width: 100%;
    cursor: pointer;
    box-shadow: none;
    transition: border-color 0.15s ease-in-out;
}

/* Effetto al click/focus */
.sa-select-prestazioni:focus {
    border-color: #80bdff;
    /* Colore primario (bootstrap blue) */
    outline: 0;
    box-shadow: none;
    /* Rimuove l'ombra pesante di default */
}

/* Stile speciale quando il placeholder (null) è selezionato */
.sa-select-prestazioni:invalid,
.sa-select-prestazioni option[value=""][disabled] {
    color: #999;
}
</style>